import script from "./kaochangtongyi.vue?vue&type=script&setup=true&lang=js"
export * from "./kaochangtongyi.vue?vue&type=script&setup=true&lang=js"

import "./kaochangtongyi.vue?vue&type=style&index=0&id=16fe9e6c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fe9e6c"]])

export default __exports__